import type { ComparisonSpec } from "@/api/analytics/comparison";
import { comparisonToQuery } from "@/api/analytics/comparison";
import {
  type FilterDefinition,
  type QuerySegment,
  normalizeFilterRequest,
  serializeFilterQuerySegments,
} from "@/features/table-filters/contract";

export function composeAnalyticsRequest<
  BaseFilters extends object,
  ViewState extends object = Record<string, never>,
  DrillDownState extends object = Record<string, never>,
>(
  definitions: readonly FilterDefinition<BaseFilters>[],
  baseFilters: Partial<BaseFilters>,
  viewState?: ViewState,
  drillDownState?: DrillDownState,
): BaseFilters & ViewState & DrillDownState {
  return {
    ...normalizeFilterRequest(definitions, baseFilters),
    ...(viewState ?? ({} as ViewState)),
    ...(drillDownState ?? ({} as DrillDownState)),
  } as BaseFilters & ViewState & DrillDownState;
}

export function serializeAnalyticsQuery(
  segments: readonly QuerySegment[],
): URLSearchParams {
  return serializeFilterQuerySegments(segments);
}

export function appendComparisonQuery(
  params: URLSearchParams,
  comparison: ComparisonSpec | null | undefined,
): void {
  if (comparison === undefined) return;
  Object.entries(comparisonToQuery(comparison)).forEach(([key, value]) => {
    params.append(key, String(value));
  });
}
